var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',[_c('Title',{attrs:{"subtitle":_vm.$t('error404.subtitle'),"title":_vm.$t('error404.title')}}),_c('section',{staticClass:"content pb-120"},[_c('div',{staticClass:"content__inner"},[_c('section',{staticClass:"mb-60"},[_c('p',{staticClass:"mb-30",domProps:{"innerHTML":_vm._s(_vm.$sanitize(_vm.$t('error404.message')))}})])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }